import { Box, Button, Modal, Stack, Typography } from "@mui/material";

interface UploadTagSuccessModalProps {
  open: boolean;
  title: string;
  messsage: string;
  handleClose:() => void;
}

export const UploadTagSuccessModal = ({open, title, messsage, handleClose}: UploadTagSuccessModalProps) => {
  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ 
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: '650px',
        bgcolor: 'background.paper',
        border: '1px solid #909894',
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius:'16px',
        p: 4,
       }}>
        <Typography id="modal-title" variant="h4" component="h2" fontWeight="600" color="#009444">
          { title ?? 'Upload Successful' }
        </Typography>
        <Stack mt={4} spacing={4}>
          <Stack alignItems="center" justifyContent="center" 
            dangerouslySetInnerHTML={{ __html: messsage }} sx={{
              '& p': {
                textAlign: 'center',
              },
              '& .records': {
                fontFamily: 'korolev-condensed',
                fontWeight: '600',
                color: '#009444',
                fontSize: '3.75rem',
                lineHeight: 1.2,
              },
            }}
          >
          </Stack>
          <Stack direction='row' spacing={2}>
            <Button variant="contained" size="large" onClick={handleClose}>
              Ok
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  )
}